export default function BindGrouping(){
    let dom = document.getElementById("group-id");
    if(dom){
        let content = dom.innerText;
        if(content){
            localStorage.setItem('Group', content.trim());
        }
    }
}